// src/components/common/HeroSection.js
import React from 'react';
import { Link } from 'react-router-dom';

import FancyButton from './fancyButton'; // Note: Ensure filename matches (case-sensitive)

import './heroSection.css';

function HeroSection({
  tagline,
  description,
  primaryButton,
  secondaryButton,
  logoSrc,
  heroImageSrc,
  supportImageSrc,
}) {
  return (
    <section className="hero-section">
      <div className="hero-content">
        {logoSrc && (
          <img src={logoSrc} alt="MostLearned" className="hero-brand-mark" loading="eager" />
        )}
        <h1 className="hero-tagline">{tagline}</h1>
        <p className="hero-description">{description}</p>
        <div className="hero-buttons">
          {primaryButton && (
            <Link to={primaryButton.link}>
              <FancyButton variant="primary">{primaryButton.text}</FancyButton>
            </Link>
          )}
          {secondaryButton && (
            <Link to={secondaryButton.link}>
              <FancyButton variant="secondary">{secondaryButton.text}</FancyButton>
            </Link>
          )}
        </div>
        {(heroImageSrc || supportImageSrc) && (
          <div className="hero-visuals">
            {heroImageSrc && (
              <img
                src={heroImageSrc}
                alt="MostLearned platform preview"
                className="hero-visual hero-visual--primary"
                loading="eager"
              />
            )}
            {supportImageSrc && (
              <img
                src={supportImageSrc}
                alt="Learner success visual"
                className="hero-visual hero-visual--secondary"
                loading="lazy"
              />
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default HeroSection;
